import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";

export default function RequireCourse(props: any) {
	const course = useAppSelector((state) => state.user.course);
	const navigate = useNavigate();

	useEffect(() => {
		if (!course) {
			navigate("/courses");
		}
	});

	if (!course) return null;

	return <Outlet />;
}
